import React from "react";
import styles from "./continue-btn.module.css";
import {useSelector} from "react-redux";
import { getPaywallPage } from "src/shared/utils/get-paywall-page";
import { removeLocalStorage, StorageKey } from "src/shared/utils/localStorages";

const ContinueButton = () => {

  const guestId = useSelector((store) => store.guestId);
  // const resultLink = `https://front-dev.zodiaq.vip/horoscopes?userId=${guestId}&source=messenger`;
  // TODO брать аргумент для getPaywallPage из LS
  const paywallPage = getPaywallPage('messenger')
  const resultLink = `https://zodiaq.vip/${paywallPage}?userId=${guestId}&source=messenger`;

    const handleContinue = () => {
      removeLocalStorage(StorageKey.UserId);
    };

  return <a className={styles.link} href={resultLink} onClick={handleContinue}>Continue &gt;&gt;&gt;</a>;
};

export { ContinueButton };
